import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth, User } from 'firebase';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TrackerService } from 'src/app/services/tracker.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public currentUser: User;
  public isAuth$: Observable<boolean>;
  public sampleListExists: boolean;

  constructor(private afAuth: AngularFireAuth, private tracker: TrackerService) {
    this.isAuth$ = this.afAuth.user.pipe(
      tap(user => (this.currentUser = user)),
      tap(user => this.tracker.setUser(user)),
      map(m => m !== null)
    );
  }

  public async socialLogin(providerString: string = 'facebook') {
    let provider;

    switch (providerString) {
      case 'facebook':
        provider = new auth.FacebookAuthProvider();
        break;
      default:
    }

    const isFacebookInAppBrowser = () => {
      const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
      return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
    };
    this.tracker.trackLogin(providerString);
    return isFacebookInAppBrowser()
      ? this.afAuth.auth.signInWithRedirect(provider)
      : this.afAuth.auth.signInWithPopup(provider);
  }

  public async loginWithEmailAndPassword(email: string, password: string) {
    this.tracker.trackLogin('email');
    return this.afAuth.auth.signInWithEmailAndPassword(email, password);
  }

  public async createUserWithEmailAndPassword(email: string, password: string) {
    this.tracker.trackRegister();
    const userCredential = await this.afAuth.auth.createUserWithEmailAndPassword(email, password);
    const displayName = userCredential.user.email.split('@')[0];
    await userCredential.user.updateProfile({ displayName });
    await userCredential.user.sendEmailVerification();
  }

  public async logout() {
    this.tracker.trackLogout();
    return this.afAuth.auth.signOut();
  }
}
